var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 11.6875C1.015 11.6875 0.685417 11.5483 0.41125 11.2698C0.137083 10.9914 0 10.6566 0 10.2656V1.73438C0 1.34336 0.137083 1.00863 0.41125 0.730176C0.685417 0.451725 1.015 0.3125 1.4 0.3125H12.6C12.985 0.3125 13.3146 0.451725 13.5887 0.730176C13.8629 1.00863 14 1.34336 14 1.73438V10.2656C14 10.6566 13.8629 10.9914 13.5887 11.2698C13.3146 11.5483 12.985 11.6875 12.6 11.6875H1.4ZM7 6.71094L1.4 3.15625V10.2656H12.6V3.15625L7 6.71094ZM7 5.28906L12.6 1.73438H1.4L7 5.28906ZM1.4 3.15625V1.73438V10.2656V3.15625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.15b1bfb9038e212349779d2b8bd90b40.svg";
export { ForwardRef as ReactComponent };